"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const honest_react_1 = require("@digitools/honest-react");
const react_router_dom_1 = require("react-router-dom");
const Nav_scss_1 = __importDefault(require("./Nav.scss"));
const Nav = ({ homePageUrl }) => ((0, jsx_runtime_1.jsxs)("nav", { className: Nav_scss_1.default.nav, children: [(0, jsx_runtime_1.jsx)(react_router_dom_1.Link, { to: homePageUrl, children: (0, jsx_runtime_1.jsx)(honest_react_1.Icon, { className: `${Nav_scss_1.default.navHover} mr-3`, name: 'home' }) }), (0, jsx_runtime_1.jsx)(honest_react_1.Icon, { className: 'mr-3', name: 'angle-double-right' }), (0, jsx_runtime_1.jsx)("span", { className: Nav_scss_1.default.navHover, children: "Search" })] }));
exports.default = Nav;
